<script>
    import BaseTooltip from "@main/packages/BaseTooltip";

    export default {
        name: "LiteCompareIcon",
        components: {
            BaseTooltip,
        },
        props: {
            icons: {
                type: [Array, Object],
                required: true,
            },
            positionX: {
                type: String,
                default: "right",
            },
        },
    };
</script>

<template>
    <div class="lite-compare-icon">
        <template v-if="Array.isArray(icons)">
            <div
                class="lite-compare-icon__image"
                v-for="(subIcon, subIconIndex) in icons"
                :key="subIconIndex"
            >
                <img :src="`/static/assets/lite-compare/${$_name}/${subIcon.image}`" alt="" />
                <base-tooltip v-if="subIcon.tooltip" :position-x="positionX">
                    {{ subIcon.tooltip }}
                </base-tooltip>
            </div>
        </template>

        <div v-else class="lite-compare-icon__image">
            <img :src="`/static/assets/lite-compare/${$_name}/${icons.image}`" alt="" />
            <base-tooltip v-if="icons.tooltip" :position-x="positionX">
                {{ icons.tooltip }}
            </base-tooltip>
        </div>
    </div>
</template>

<style lang="scss">
    .lite-compare-icon {
        display: flex;
        justify-content: center;
    }

    .lite-compare-icon__image {
        position: relative;
        max-height: 28px;
        img {
            height: 100%;
        }
        &:hover {
            .base-tooltip {
                display: block;
            }
        }
    }
</style>
